/** English strings — polish round 1: pause → main menu (docs/06). */
export const enPolish = {
  'pause.home': 'MAIN MENU',
  'pause.homeSaved': 'Your run is saved — CONTINUE picks it up right here.',
  'pause.homeRewind': 'This fight is lost — CONTINUE goes back to the last save.',
  'pause.homeLost': 'Nothing is saved yet — this run ends.',
} as const;
